import Vue from 'vue'
import XYConfirmDialog from '@/components/common/XYConfirm/XYConfirmDialog.vue'

const XYConfirmDialogConstructor = Vue.extend(XYConfirmDialog)

export default function (options) {
  return new Promise((resolve, reject) => {
    const instance = new XYConfirmDialogConstructor({
      data: {
        ...options,
        onConfirm() {
          resolve()
        },
        onCancel() {
          reject()
        }
      }
    })
    instance.$mount()
    document.body.appendChild(instance.$el)
    instance.visible = true
  })
}
